import React from 'react'
import { withRouter } from 'react-router-dom'
import { isBrowser } from 'react-device-detect'
import { TweenMax } from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin'

const TabNavItem = withRouter((props) => {
    const handleClick = event => {
        event.preventDefault()
        props.history.push(props.to)

        const subNav = document.getElementById('sub-navigation')
        const subNavMobile = document.getElementById('sub-navigation-mobile')

        if (isBrowser) {
            TweenMax.to(window, 0.5, { scrollTo: { y: subNav, offsetY: 60 } })
        } else {
            TweenMax.to(window, 0.5, { scrollTo: { y: subNavMobile, offsetY: 50 } })
        }
    }

    return (
        <a href='#' onClick={handleClick} className={props.className ? props.className : ''}>{props.children}</a>
    )
})

export default withRouter(TabNavItem)



// WEBPACK FOOTER //
// ./resources/js/elements/TabNavItem.js